"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Item_1 = __importDefault(require("@features/ItemCommon/components/Item"));
var react_1 = __importStar(require("react"));
function ImplioItem(_a) {
    var _b, _c;
    var job = _a.job, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, updateItemCurrent = _a.updateItemCurrent, updateItemCustomerSpecific = _a.updateItemCustomerSpecific, updateFeedback = _a.updateFeedback, editPermissions = _a.editPermissions, template = _a.template, index = _a.index, updateModerationNotes = _a.updateModerationNotes, hideReviewBar = _a.hideReviewBar, onSelectDecision = _a.onSelectDecision, _d = _a.showModerationNoteIndicator, showModerationNoteIndicator = _d === void 0 ? true : _d, enableKeyboardShortcuts = _a.enableKeyboardShortcuts, editMode = _a.editMode, setCurrentItem = _a.setCurrentItem, changeFocusedElement = _a.changeFocusedElement;
    var _e = __read((0, react_1.useState)({}), 2), showBoundingBox = _e[0], setShowBoundingBox = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), isNoteExpanded = _f[0], setIsNoteExpanded = _f[1];
    // Go to feedback page if there is at least one feedback
    (0, react_1.useEffect)(function () {
        var _a;
        if (((_a = job === null || job === void 0 ? void 0 : job.moderationNotes) === null || _a === void 0 ? void 0 : _a.notes) && job.moderationNotes.notes.length > 0) {
            setIsNoteExpanded(true);
        }
    }, [(_c = (_b = job === null || job === void 0 ? void 0 : job.moderationNotes) === null || _b === void 0 ? void 0 : _b.notes) === null || _c === void 0 ? void 0 : _c.length]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "row eva-job-notices-row" },
            react_1.default.createElement(Item_1.default, { job: job, domain: domain, angularJsDependencies: angularJsDependencies, index: index, isNoteExpanded: isNoteExpanded, showBoundingBox: showBoundingBox, updateItemCurrent: updateItemCurrent, updateItemCustomerSpecific: updateItemCustomerSpecific, editPermissions: editPermissions, template: template, editMode: editMode, setCurrentItem: setCurrentItem, setShowBoundingBox: setShowBoundingBox, setIsNoteExpanded: setIsNoteExpanded, showModerationNoteIndicator: showModerationNoteIndicator, updateModerationNotes: updateModerationNotes, hideReviewBar: hideReviewBar, updateFeedback: updateFeedback, onSelectDecision: onSelectDecision, enableKeyboardShortcuts: enableKeyboardShortcuts, changeFocusedElement: changeFocusedElement }))));
}
exports.default = ImplioItem;
